import * as React from 'react'

import { CheckIcon, KeyboardIcon } from 'lucide-react'

import LocationIcon from '~/client/src/shared/components/LocationIcon/LocationIcon'
import MapViewLocationIcon from '~/client/src/shared/enums/SitemapAttributeIcon'

import FieldIds from '../../enums/DeliveryFieldIds'
import * as Icons from '../Icons'

import './DeliveryFieldIcon.scss'

interface IProps {
  fieldId: FieldIds | string
  isConcreteDirect?: boolean
}

const FIELD_CLASS_NAME = 'delivery-field-icon with-color no-grow'
const FIELD_CLASS_NAME_WITHOUT_COLOR = 'delivery-field-icon no-grow'
const CONCRETE_MATERIAL_ID = 'ConcreteDirectMaterial'

const deliveryFieldIdToIconMap: { [key: string]: JSX.Element } = {
  [FieldIds.ID]: <Icons.IdIcon className={FIELD_CLASS_NAME} />,
  [FieldIds.COMPANY]: <Icons.Team className={FIELD_CLASS_NAME} />,
  [FieldIds.BOOKING_TIME]: <Icons.Clock className={FIELD_CLASS_NAME} />,
  [FieldIds.STATUS]: (
    <CheckIcon
      size={16}
      className={`${FIELD_CLASS_NAME_WITHOUT_COLOR} stroke-icon`}
    />
  ),
  [FieldIds.BUILDING]: (
    <LocationIcon
      iconName={MapViewLocationIcon.Building}
      className={FIELD_CLASS_NAME}
    />
  ),
  [FieldIds.ZONE]: (
    <LocationIcon
      iconName={MapViewLocationIcon.Zone}
      className={FIELD_CLASS_NAME}
    />
  ),
  [FieldIds.OFFLOADING_EQUIPMENT]: (
    <LocationIcon
      iconName={MapViewLocationIcon.Equipment}
      className={FIELD_CLASS_NAME}
    />
  ),
  [FieldIds.GATE]: (
    <LocationIcon
      iconName={MapViewLocationIcon.Gate}
      className={`${FIELD_CLASS_NAME_WITHOUT_COLOR} stroke-icon`}
    />
  ),
  [FieldIds.ROUTE]: (
    <LocationIcon
      iconName={MapViewLocationIcon.Route}
      className={FIELD_CLASS_NAME}
    />
  ),
  [FieldIds.LEVEL]: (
    <LocationIcon
      iconName={MapViewLocationIcon.Level}
      className={FIELD_CLASS_NAME}
    />
  ),
  [FieldIds.AREA]: (
    <LocationIcon
      iconName={MapViewLocationIcon.Area}
      className={FIELD_CLASS_NAME}
    />
  ),
  [FieldIds.MATERIAL_CATEGORY]: <Icons.Material className={FIELD_CLASS_NAME} />,
  [FieldIds.MATERIAL_NOTE]: (
    <KeyboardIcon
      size={16}
      className={`${FIELD_CLASS_NAME_WITHOUT_COLOR} stroke-icon`}
    />
  ),
  [FieldIds.VENDOR]: <Icons.Vendor className={FIELD_CLASS_NAME} />,
  [FieldIds.TRUCK_SIZE]: <Icons.Truck className={FIELD_CLASS_NAME} />,
  [FieldIds.DRIVER_PHONE_NUMBERS]: (
    <Icons.Mobile className={FIELD_CLASS_NAME} />
  ),
  [FieldIds.ON_SITE_CONTACTS]: (
    <Icons.BallInCourt className={FIELD_CLASS_NAME} />
  ),
  [CONCRETE_MATERIAL_ID]: (
    <Icons.ConcreteDirect className={FIELD_CLASS_NAME_WITHOUT_COLOR} />
  ),
}

export default function DeliveryFieldIcon({
  fieldId,
  isConcreteDirect,
}: IProps) {
  if (fieldId === FieldIds.MATERIAL_CATEGORY && isConcreteDirect) {
    return deliveryFieldIdToIconMap[CONCRETE_MATERIAL_ID]
  }

  return deliveryFieldIdToIconMap[fieldId] || null
}
